module.exports = __webpack_public_path__ + "img/portrait.3e56a9eb.png";